import React, { FC } from "react";
import useBrandColor from "@src/features/settings/hooks/useBrandColor";
import { addOpacityToHexColor } from "@src/lib/utils/color";

type Props = {
  centerContent: React.ReactNode;
  footerContent?: React.ReactNode;
  overlayContent?: React.ReactNode;
};

const PromptMediaFileAndLinkContainer: FC<Props> = (props) => {
  const brandColor = useBrandColor();

  return (
    <div
      id={"PromptMediaFileAndLinkContainer"}
      className="relative flex flex-1 flex-col self-stretch p-[22px]"
      style={{
        backgroundColor: addOpacityToHexColor(brandColor, 0.2),
      }}
    >
      {props.footerContent && <div className="flex-1" />}
      <div className="flex flex-1 flex-col items-center justify-center self-stretch">
        {props.centerContent}
      </div>
      {props.footerContent && (
        <div className="flex flex-1 flex-col justify-end self-stretch">
          {props.footerContent}
        </div>
      )}
      {props.overlayContent}
    </div>
  );
};

export default PromptMediaFileAndLinkContainer;
